import { getAccessToken } from "../repositories/security";
import { User } from "oidc-client-ts";

export async function getApiToken(oktaUser: User | null | undefined) {
  return getAccessToken(oktaUser);
}
